import { LoaderFunction } from 'react-router-dom';
import { client } from '~/api/client';
import { loadQuery } from '~/api/data/responses';
import { mapResult } from '~/api/data/result';
import {
  GetAccountDocument,
  GetAccountQuery,
  GetAccountQueryVariables,
  GetAccountsDocument,
  GetAccountsQuery,
  GetAccountsQueryVariables,
  GetCertificateDocument,
  GetCertificateQuery,
  GetCertificateQueryVariables
} from '~/api/graphql';

export const getAccounts = async () =>
  mapResult(
    await client.query<GetAccountsQuery, GetAccountsQueryVariables>({ query: GetAccountsDocument }),
    (data) => data?.accounts || []
  );

export const getAccount = async (id: string) =>
  mapResult(
    await client.query<GetAccountQuery, GetAccountQueryVariables>({
      query: GetAccountDocument,
      variables: { id }
    }),
    (data) => data?.account
  );

export const getCertificate = async (id: string) =>
  mapResult(
    await client.query<GetCertificateQuery, GetCertificateQueryVariables>({
      query: GetCertificateDocument,
      variables: { id }
    }),
    (data) => data?.certificate
  );

export const loadAccounts: LoaderFunction = () =>
  loadQuery(getAccounts(), { notFoundRedirect: '/app/accounts', suppressAuthErrors: true });

export const loadAccount: LoaderFunction = ({ params }) =>
  loadQuery(getAccount(params.id || ''), { notFoundRedirect: '/app/accounts' });

export const loadCertificate: LoaderFunction = ({ params }) =>
  loadQuery(getCertificate(params.certificateId || ''));
